<template>
  <div :style="{ display: 'inline-flex' }" v-bind="containerAttrs">
    <!-- 支持水印 -->
    <ll-watermark
      v-if="Array.isArray(content) ? content.length > 0 : content"
      :class="`${bem.b('watermark')}`"
      v-bind="componentAttrs"
      :style="getImageStyle"
      :content="props.content"
      :width="props.watermarkWidth"
      :height="props.watermarkHeight"
      :z-index="100"
    >
      <div
        :class="[
          bem.b('container'),
          $slots.previewMask ? '' : bem.is('no-preview-mask'),
          getImageClass,
        ]"
        :style="getImageStyle"
      >
        <a-image
          :class="`${bem.b()}`"
          :style="{ 'object-fit': props.objectFit }"
          v-bind="props"
          :src="getSrc"
          :fallback="computedFallback"
        >
          <!-- 占位插槽 -->
          <template #placeholder>
            <slot name="placeholder" />
          </template>
          <!-- 自定义mask插槽 -->
          <template #previewMask>
            <slot name="previewMask">
              <div
                :class="bem.e('preview-mask')"
                :style="{ background: props.maskColor }"
              >
                <slot name="previewMaskContent">
                  <ll-icon
                    :class="bem.e('preview-icon')"
                    :icon-name="props.previewIcon"
                    :size="props.iconSize"
                  />
                </slot>
              </div>
            </slot>
          </template>
        </a-image>
      </div>
    </ll-watermark>

    <!-- 默认的图片展示 -->
    <template v-else>
      <div
        :class="[
          bem.b('container'),
          $slots.previewMask ? '' : bem.is('no-preview-mask'),
          getImageClass,
        ]"
        :style="getImageStyle"
      >
        <a-image
          :class="`${bem.b()}`"
          :style="{ 'object-fit': props.objectFit }"
          v-bind="props"
          :src="getSrc"
          :fallback="computedFallback"
        >
          <!-- 占位插槽 -->
          <template #placeholder>
            <slot name="placeholder" />
          </template>
          <!-- 自定义mask插槽 -->
          <template #previewMask>
            <slot name="previewMask">
              <div
                :class="bem.e('preview-mask')"
                :style="{ background: props.maskColor }"
              >
                <slot name="previewMaskContent">
                  <ll-icon
                    :class="bem.e('preview-icon')"
                    :icon-name="props.previewIcon"
                    :size="props.iconSize"
                  />
                </slot>
              </div>
            </slot>
          </template>
        </a-image>
      </div>
    </template>
  </div>
</template>
<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { computed, useAttrs } from 'vue'
import { imageProps } from './image'

import { omit } from 'lodash-es'
import { FALL_BACK_IMG } from './image'

defineOptions({
  name: 'LlImage',
  inheritAttrs: false,
})
const attrs = useAttrs()

const props = defineProps(imageProps)

const bem = createNamespace('image')

// 容器样式
const containerAttrs = computed(() => ({
  class: attrs.class as any,
  style: attrs.style as any,
}))

// 组件功能相关的属性
const componentAttrs = computed(() => {
  return omit(attrs, ['class', 'style'])
})

// 加载失败容错地址
const computedFallback = computed(() =>
  props.fallback ? props.fallback : FALL_BACK_IMG
)
// 根据isShowBorder/borderRadius设置类名
const getImageClass = computed(() => {
  const borderClass = props.isShowBorder ? bem.m('border') : ''
  return `${borderClass}`
})
const getImageStyle = computed(() => {
  return { borderRadius: props.borderRadius, overflow: 'hidden' }
})
const getSrc = computed(() => {
  return props.src ? props.src : FALL_BACK_IMG
})
</script>
